import { get } from './axiosInstance';
import { isMockMode } from '../mocks/isMockMode';
import { getDocsDummyBankAccounts } from '../mocks/bankAccountMocks';

const bankAccountApi = "/api/bankAccount";

export const getByUser = async () => {
    let result = {
        isSuccess: false,
        data: null,
        errorCode: null
    }
    if (isMockMode()) {
        result.data = getDocsDummyBankAccounts();
        result.isSuccess = true;
        return result;
    }
    try {
        result.data = await get(`${bankAccountApi}/get-user-bank-accounts`);
        result.isSuccess = true;
    } catch (error) {
        result.errorCode = "ERR001";
    }
    return result;
}